import React from "react";
import { Link } from "react-router-dom";
import { Lock } from "lucide-react";
import { Button } from "./primitives";

/** Shown in place of a page the signed-in user hasn't been given access to. */
export const AccessDenied: React.FC<{ name?: string; homeTo?: string }> = ({ name, homeTo = "/dashboard" }) => (
  <div className="flex min-h-[55vh] flex-col items-center justify-center px-4 text-center">
    <div className="flex h-16 w-16 items-center justify-center rounded-full bg-slate-100 text-slate-400">
      <Lock className="h-7 w-7" />
    </div>
    <h1 className="mt-5 text-lg font-semibold text-slate-900">{name ? `You don't have access to ${name}` : "You don't have access to this page"}</h1>
    <p className="mt-2 max-w-md text-sm text-slate-500">
      This area hasn't been enabled for your account. If you need it for your work, please ask your administrator to grant you access.
    </p>
    <Link to={homeTo} className="mt-5">
      <Button variant="outline">Go to my home page</Button>
    </Link>
  </div>
);
